"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ = require("./");

class Evaluator {
  static thaw(evaluatorObj) {
    if (evaluatorObj == null) return null;
    const evaluator = new Evaluator();
    if (evaluatorObj.doingBusinessAsName != null) evaluator.setDoingBusinessAsName(evaluatorObj.doingBusinessAsName);
    if (evaluatorObj.independentLogoUrl != null) evaluator.setIndependentLogoUrl(evaluatorObj.independentLogoUrl);
    if (evaluatorObj.rangeOfTravel != null) evaluator.setRangeOfTravel(evaluatorObj.rangeOfTravel);
    if (evaluatorObj.receiveReferrals != null) evaluator.setReceiveReferrals(evaluatorObj.receiveReferrals == null ? null : evaluatorObj.receiveReferrals ? true : false);
    if (evaluatorObj.stripeCustomerId != null) evaluator.setStripeCustomerId(evaluatorObj.stripeCustomerId);
    if (evaluatorObj.stripePaymentMethodId != null) evaluator.setStripePaymentMethodId(evaluatorObj.stripePaymentMethodId);
    if (evaluatorObj.notes != null) evaluator.setNotes(evaluatorObj.notes);
    if (evaluatorObj.percentRetainedForIndependentEvaluation != null) evaluator.setPercentRetainedForIndependentEvaluation(evaluatorObj.percentRetainedForIndependentEvaluation);
    if (evaluatorObj.personId != null) evaluator.setPersonId(evaluatorObj.personId);
    if (evaluatorObj.workAddressId != null) evaluator.setWorkAddressId(evaluatorObj.workAddressId);
    if (evaluatorObj.person != null) evaluator.setPerson(_.Person.thaw(evaluatorObj.person));
    if (evaluatorObj.workAddress != null) evaluator.setWorkAddress(_.Address.thaw(evaluatorObj.workAddress));
    if (evaluatorObj.evaluationRequests != null) evaluator.setEvaluationRequests(_.EvaluationRequest.thawList(evaluatorObj.evaluationRequests));
    if (evaluatorObj.evaluatorCertifications != null) evaluator.setEvaluatorCertifications(_.EvaluatorCertification.thawList(evaluatorObj.evaluatorCertifications));
    if (evaluatorObj.evaluatorTrainings != null) evaluator.setEvaluatorTrainings(_.EvaluatorTraining.thawList(evaluatorObj.evaluatorTrainings));
    if (evaluatorObj.backgroundChecks != null) evaluator.setBackgroundChecks(_.BackgroundCheck.thawList(evaluatorObj.backgroundChecks));
    if (evaluatorObj.checkrCandidateId != null) evaluator.setCheckrCandidateId(evaluatorObj.checkrCandidateId);
    return evaluator;
  }

  static thawList(evaluatorObjList) {
    if (evaluatorObjList == null) return [];
    var evaluators = [];

    for (var i = 0; i < evaluatorObjList.length; i++) {
      evaluators.push(Evaluator.thaw(evaluatorObjList[i]));
    }

    return evaluators;
  }

  static freeze(evaluator) {
    if (evaluator == null) return null;
    var evaluatorObj = {};
    if (evaluator.getDoingBusinessAsName() != null) evaluatorObj.doingBusinessAsName = evaluator.getDoingBusinessAsName();
    if (evaluator.getIndependentLogoUrl() != null) evaluatorObj.independentLogoUrl = evaluator.getIndependentLogoUrl();
    if (evaluator.getRangeOfTravel() != null) evaluatorObj.rangeOfTravel = evaluator.getRangeOfTravel();
    if (evaluator.getReceiveReferrals() != null) evaluatorObj.receiveReferrals = evaluator.getReceiveReferrals() == null ? null : evaluator.getReceiveReferrals() ? 1 : 0;
    if (evaluator.getStripeCustomerId() != null) evaluatorObj.stripeCustomerId = evaluator.getStripeCustomerId();
    if (evaluator.getStripePaymentMethodId() != null) evaluatorObj.stripePaymentMethodId = evaluator.getStripePaymentMethodId();
    if (evaluator.getNotes() != null) evaluatorObj.notes = evaluator.getNotes();
    if (evaluator.getPercentRetainedForIndependentEvaluation() != null) evaluatorObj.percentRetainedForIndependentEvaluation = evaluator.getPercentRetainedForIndependentEvaluation();
    if (evaluator.getPersonId() != null) evaluatorObj.personId = evaluator.getPersonId();
    if (evaluator.getWorkAddressId() != null) evaluatorObj.workAddressId = evaluator.getWorkAddressId();
    if (evaluator.getPerson() != null) evaluatorObj.person = _.Person.freeze(evaluator.getPerson());
    if (evaluator.getWorkAddress() != null) evaluatorObj.workAddress = _.Address.freeze(evaluator.getWorkAddress());
    if (evaluator.getEvaluationRequests() != null) evaluatorObj.evaluationRequests = _.EvaluationRequest.freezeList(evaluator.getEvaluationRequests());
    if (evaluator.getEvaluatorCertifications() != null) evaluatorObj.evaluatorCertifications = _.EvaluatorCertification.freezeList(evaluator.getEvaluatorCertifications());
    if (evaluator.getEvaluatorTrainings() != null) evaluatorObj.evaluatorTrainings = _.EvaluatorTraining.freezeList(evaluator.getEvaluatorTrainings());
    if (evaluator.getBackgroundChecks() != null) evaluatorObj.backgroundChecks = _.BackgroundCheck.freezeList(evaluator.getBackgroundChecks());
    if (evaluator.getCheckrCandidateId() != null) evaluatorObj.checkrCandidateId = evaluator.getCheckrCandidateId();
    return evaluatorObj;
  }

  static freezeList(evaluators) {
    if (evaluators == null) return [];
    var evaluatorObjList = [];

    for (var i = 0; i < evaluators.length; i++) {
      evaluatorObjList.push(Evaluator.freeze(evaluators[i]));
    }

    return evaluatorObjList;
  }

  constructor() {
    this.setDoingBusinessAsName(null);
    this.setIndependentLogoUrl(null);
    this.setRangeOfTravel(null);
    this.setReceiveReferrals(null);
    this.setStripeCustomerId(null);
    this.setStripePaymentMethodId(null);
    this.setNotes(null);
    this.setPercentRetainedForIndependentEvaluation(null);
    this.setPersonId(null);
    this.setWorkAddressId(null);
    this.setPerson(null);
    this.setWorkAddress(null);
    this.setEvaluationRequests(null);
    this.setEvaluatorCertifications(null);
    this.setEvaluatorTrainings(null);
    this.setBackgroundChecks(null);
    this.setCheckrCandidateId(null);
  }
  /* -------------------------
     -------------------------
     -------- SETTERS --------
     -------------------------
     ------------------------- */


  setDoingBusinessAsName(doingBusinessAsName) {
    this.doingBusinessAsName = doingBusinessAsName;
  }

  setIndependentLogoUrl(independentLogoUrl) {
    this.independentLogoUrl = independentLogoUrl;
  }

  setRangeOfTravel(rangeOfTravel) {
    this.rangeOfTravel = rangeOfTravel;
  }

  setReceiveReferrals(receiveReferrals) {
    this.receiveReferrals = receiveReferrals;
  }

  setStripeCustomerId(stripeCustomerId) {
    this.stripeCustomerId = stripeCustomerId;
  }

  setStripePaymentMethodId(stripePaymentMethodId) {
    this.stripePaymentMethodId = stripePaymentMethodId;
  }

  setNotes(notes) {
    this.notes = notes;
  }

  setPercentRetainedForIndependentEvaluation(percentRetainedForIndependentEvaluation) {
    this.percentRetainedForIndependentEvaluation = percentRetainedForIndependentEvaluation;
  }

  setPersonId(personId) {
    this.personId = personId;
  }

  setWorkAddressId(workAddressId) {
    this.workAddressId = workAddressId;
  }

  setPerson(person) {
    this.person = person;
  }

  setWorkAddress(workAddress) {
    this.workAddress = workAddress;
  }

  setEvaluationRequests(evaluationRequests) {
    this.evaluationRequests = evaluationRequests;
  }

  setEvaluatorCertifications(evaluatorCertifications) {
    this.evaluatorCertifications = evaluatorCertifications;
  }

  setEvaluatorTrainings(evaluatorTrainings) {
    this.evaluatorTrainings = evaluatorTrainings;
  }

  setBackgroundChecks(backgroundChecks) {
    this.backgroundChecks = backgroundChecks;
  }

  setCheckrCandidateId(checkrCandidateId) {
    this.checkrCandidateId = checkrCandidateId;
  }
  /* -------------------------
     -------------------------
     -------- GETTERS --------
     -------------------------
     ------------------------- */


  getDoingBusinessAsName() {
    return this.doingBusinessAsName;
  }

  getIndependentLogoUrl() {
    return this.independentLogoUrl;
  }

  getRangeOfTravel() {
    return this.rangeOfTravel;
  }

  getReceiveReferrals() {
    return this.receiveReferrals;
  }

  getStripeCustomerId() {
    return this.stripeCustomerId;
  }

  getStripePaymentMethodId() {
    return this.stripePaymentMethodId;
  }

  getNotes() {
    return this.notes;
  }

  getPercentRetainedForIndependentEvaluation() {
    return this.percentRetainedForIndependentEvaluation;
  }

  getPersonId() {
    return this.personId;
  }

  getWorkAddressId() {
    return this.workAddressId;
  }

  getPerson() {
    return this.person;
  }

  getWorkAddress() {
    return this.workAddress;
  }

  getEvaluationRequests() {
    return this.evaluationRequests;
  }

  getEvaluatorCertifications() {
    return this.evaluatorCertifications;
  }

  getEvaluatorTrainings() {
    return this.evaluatorTrainings;
  }

  getBackgroundChecks() {
    return this.backgroundChecks;
  }

  getCheckrCandidateId() {
    return this.checkrCandidateId;
  }
  /* -------------------------
     -------------------------
     -------- HELPERS --------
     -------------------------
     ------------------------- */


}

exports.default = Evaluator;